module.exports = __webpack_public_path__ + "static/media/03.45880a68.gif";